import React from 'react';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Dialog,
  Grid,
  TextField,
  InputLabel,
  Autocomplete,
  Box,
  MenuItem,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import useHFOpsFormAddHook, { HF_TASK_TYPE_OPTIONS } from '../CustomHooks/useHFOpsFormAddHook';
import HFClockinForm from './HFClockinForm';
import HFDailyHarvestingCloseForm from './HFDailyHarvestingCloseForm';
import HFDailyForwardingCloseForm from './HFForwardingform';
import HFOtherWorkCloseForm from './DailyWorkDataForm';
import HFCompletedForestForm from './Hf_Completedforestform.js.js';
import HFStockTakeForm from './HF_StockTake';
import HfexpenseClaimform from './HF_ExpenseClaimForm';
import HfOtherForm from './HF_OtherForm';
import HfHolidayForm from './HF_HolidayForm';
import HF_HelpVideos from './HF_HelpVideos';

const dropDownStyles = {
  paddingBottom: '10px',
  fontSize: '0.825rem',
  color: 'black',
};

const AddHfFormDialog = ({ open, setOpen, handleSuccessfulSubmit }) => {
  const {
    spList,
    spListObj,
    selectedTaskType,
    handleSelectTaskType,
    handleClose,

    clockInData,
    setClockInData,
    vehicalCheckList,
    setVehicalChecklist,

    harvestingMaintenanceCheckList,
    setHarvestingMaintenanceCheckList,
    harvestingClosingData,
    setHarvestingClosingData,
    productionData,
    setProductionData,

    forwardingData,
    setForwardingData,
    forwardingMaintenanceCheckListData,
    setForwardingMaintenanceCheckListData,

    dailyOtherWorkCloseData,
    setDailyOtherWorkCloseData,

    completedForestData,
    setCompletedForestData,

    stockTakeData,
    setStockTakeData,
    expenseClaimData,
    setExpenseClaimData,
    otherTaskData,
    setOtherTaskData,
    holidayData,
    setHolidayData,

    files,
    setNewUploadedFiles,
    handleFileChange,
    handleDeleteFiles,
    viewFile,
    isLoading,

    submitNewTask,
    machineList,
  } = useHFOpsFormAddHook(open, setOpen, handleSuccessfulSubmit);

  return (
    <Dialog
      sx={{
        fontFamily: 'Normal !important',
        '& .MuiDialog-paperScrollPaper': { overflow: 'hidden' },
      }}
      fullWidth
      maxWidth="lg"
      onClose={handleClose}
      aria-labelledby="add-hf-form-dialog-title"
      open={open}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="add-hf-form-dialog-title">
        Add New H/F Task
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={handleClose}
        sx={theme => ({
          position: 'absolute',
          right: 8,
          top: 8,
          color: theme.palette.grey[500],
        })}>
        <CloseIcon />
      </IconButton>
      <form
        onSubmit={e => {
          e.preventDefault();
          submitNewTask();
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && e.target.tagName !== 'TEXTAREA') {
            e.preventDefault();
          }
        }}>
        <DialogContent
          dividers
          sx={{
            height: '75vh',
            overflow: 'auto',
          }}>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: '1rem', height: '100%', paddingBlock: '0.5rem' }}>
            <TextField
              select
              required
              label="Select Task"
              value={selectedTaskType}
              onChange={e => handleSelectTaskType(e.target.value)}
              fullWidth
              size="small">
              {HF_TASK_TYPE_OPTIONS.map(opt => (
                <MenuItem key={opt} value={opt}>
                  {opt}
                </MenuItem>
              ))}
            </TextField>

            {selectedTaskType === 'Clock In' && (
              <HFClockinForm
                currentClockInData={clockInData}
                setCurrentClockInData={setClockInData}
                spList={spList}
                spListObj={spListObj}
                currentVehicalCheckList={vehicalCheckList}
                setCurrentVehicalCheckList={setVehicalChecklist}
                machineList={machineList}
              />
            )}
            {selectedTaskType === 'Daily Harvesting Close' && (
              <HFDailyHarvestingCloseForm
                currDailyHarvestingData={harvestingClosingData}
                setCurrentharvestingMaintenanceCheckListData={setHarvestingMaintenanceCheckList}
                setCurrDailyHarvestingData={setHarvestingClosingData}
                spList={spList}
                spListObj={spListObj}
                productionData={productionData}
                setProductionData={setProductionData}
                currentharvestingMaintenanceCheckListData={harvestingMaintenanceCheckList}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {selectedTaskType === 'Daily Forwarding Close' && (
              <HFDailyForwardingCloseForm
                curForwardingData={forwardingData}
                setCurrForwardinggData={setForwardingData}
                currentForwardingMaintenanceCheckListData={forwardingMaintenanceCheckListData}
                setCurrentForwardingMaintenanceCheckListData={setForwardingMaintenanceCheckListData}
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {selectedTaskType === 'Daily Other Work Close' && (
              <HFOtherWorkCloseForm
                forwadingMaintanceCheckListData={forwardingMaintenanceCheckListData}
                setForwadingMaintanceCheckListData={setForwardingMaintenanceCheckListData}
                harvestingMaintenanceCheckListData={harvestingMaintenanceCheckList}
                setHarvestingMaintenanceCheckListData={setHarvestingMaintenanceCheckList}
                otherTaskData={dailyOtherWorkCloseData}
                setOtherTaskData={setDailyOtherWorkCloseData}
                machineList={machineList}
              />
            )}
            {selectedTaskType === 'Completed Forest' && (
              <HFCompletedForestForm
                completdForestData={completedForestData}
                setCompletedForestData={setCompletedForestData}
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
                machineList={machineList}
              />
            )}
            {selectedTaskType === 'Stock Take' && (
              <HFStockTakeForm
                productionData={productionData}
                setProductionData={setProductionData}
                spList={spList}
                spListObj={spListObj}
                stockTakeData={stockTakeData}
                setStockTakeData={setStockTakeData}
              />
            )}
            {selectedTaskType === 'Expense Claim' && (
              <HfexpenseClaimform
                expenseData={expenseClaimData}
                setExpenseData={setExpenseClaimData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
            {selectedTaskType === 'Other' && (
              <HfOtherForm
                data={otherTaskData}
                setData={setOtherTaskData}
                files={files}
                setUploadedFiles={setNewUploadedFiles}
                isLoading={isLoading}
                handleFileChange={handleFileChange}
                handleDeleteFiles={handleDeleteFiles}
                viewFile={viewFile}
              />
            )}
            {selectedTaskType === 'Holidays' && <HfHolidayForm data={holidayData} setData={setHolidayData} />}
            {selectedTaskType === 'Help Videos' && <HF_HelpVideos />}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" color="primary" type="submit" disabled={!selectedTaskType}>
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddHfFormDialog;
